// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.restrictions.RentalManagerUserPropertyRestrictionsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingAlias, RentalManagerListingRestrictionsDto } from '../..';

interface GetParams {
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertyRestrictionsWebApiHandler_get_Path =
  '/api/web/v1/users/properties/restrictions/get';

/**
 * Get restrictions for a given listing
 */
export const RentalManagerUserPropertyRestrictionsWebApiHandler_get = (getParams: GetParams, client = getClient()) => {
  return httpFrontEndRequest<GetParams, never, RentalManagerListingRestrictionsDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyRestrictionsWebApiHandler_get_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
